import React from 'react'
import { ElementIcon } from '../ElementIcon'
import { ElementType, SketchElement } from '../../../../../../../inspector'
import * as S from './ElementInfo.styles'
import { ComponentName, SymbolPath } from '../../../components/ComponentName'
import { useDisplayedLayerNameAndOptionalPath } from '../useDisplayedLayerNameAndOptionalPath'

type ElementInfoProps = {
  sketchElement: SketchElement
  className?: string
}

export const ElementInfo = ({ sketchElement, className }: ElementInfoProps) => {
  const { displayedName, symbolNamePath } =
    useDisplayedLayerNameAndOptionalPath(sketchElement)

  if (!sketchElement) {
    return null
  }

  /**
   * We want to display as symbol the elements that are symbol instances
   * or the artboards that are symbol masters when the element is an artboard.
   */
  const isSymbol =
    sketchElement.type === ElementType.SymbolMaster ||
    sketchElement.type === ElementType.SymbolInstance

  return (
    <S.AttributeContainer className={className}>
      <ElementIcon
        elementType={sketchElement.type}
        // Layers that are exportable gets an extra icon on top of the
        // normal layer type icon.
        hasExports={sketchElement.isExportable}
        isSymbol={isSymbol}
      />
      <S.ComponentName>
        <ComponentName isSymbol={isSymbol}>{displayedName}</ComponentName>
        {symbolNamePath && symbolNamePath.length > 1 && (
          <SymbolPath paths={symbolNamePath} />
        )}
      </S.ComponentName>
    </S.AttributeContainer>
  )
}
